/**
 * Delete Zero
 *
 * @param  {String|Number} n
 * @return {Number}
 */
const deleteZero = (n) =>
  parseInt(n.toString().split(".")[1]) === 0 ? parseInt(n) : n;

/**
 * Number is float
 *
 * @param  {String|Number} n
 * @return {Number}
 */
const isFloat = (n) => n % 1 !== 0;

/**
 * Get money from cents
 *
 * @param  {String} crypto
 * @param  {String} satoshi
 * @return {Promise}
 */
export const centsToMoney = (cents) => {
  const currency = isFloat(cents / 10 ** 2)
    ? deleteZero((cents / 10 ** 2).toFixed(2))
    : cents / 10 ** 2;

  return currency;
};

export const converToTime = (milisegundos) => {
  // Calcula el número de horas
  const horas = Math.floor(milisegundos / 3600000);
  // Calcula el número de minutos restantes
  const minutosRestantes = Math.floor((milisegundos % 3600000) / 60000);
  // Calcula el número de segundos restantes
  const segundosRestantes = Math.floor(
    ((milisegundos % 3600000) % 60000) / 1000
  );

  const tiempoFormateado =
    pad(horas, 2) +
    ":" +
    pad(minutosRestantes, 2) +
    ":" +
    pad(segundosRestantes, 2);

  return tiempoFormateado;
};

export const msToHoursnumber = (milliseconds) => {
  if (typeof milliseconds !== "number" || milliseconds < 0) {
    throw new Error("El valor debe ser un número positivo");
  }
  return milliseconds / (1000 * 60 * 60);
};

export const msToMinutes = (milliseconds) => {
  if (typeof milliseconds !== "number" || milliseconds < 0) {
    throw new Error("El valor debe ser un número positivo");
  }
  return milliseconds / (1000 * 60);
};

const pad = (num, size) => {
  var s = num + "";
  while (s.length < size) s = "0" + s;
  return s;
};
